import { PresenceDay } from "./attendance-cau.model";

export class UpdateAttendanceCAUMassive {
    attendanceCAUFileId: string
    updatePresenceStudentCAUs: UpdateAttendanceStudentCAU[];
  }
  
  export class UpdateAttendanceCAU {
    serviceId: number;
    year: number;
    month: number;
    studentId: number;
    presenceDays: PresenceDay[];
  }

  export class UpdateAttendanceStudentCAU {
    studentId: number;
    studentName: string;
    presenceDays: PresenceDay[];
    constructor(
      studentId: number,
      studentName: string,
      presenceDays: PresenceDay[]
    ) {
      this.studentId = studentId;
      this.studentName = studentName;
      this.presenceDays = presenceDays;
    }
  }
  